import Vue from "vue";
import VueRouter from "vue-router";
import VueGtag from "vue-gtag";

import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import MyPageIndex from "../views/mc/my_page/Index.vue";
import RoomManagement from "../views/RoomManagement.vue";
import Information from "../views/mc/information/Index.vue";
import InformationDetail from "../views/information/Detail.vue";
import BoDInformation from "../views/bod/Information/Index.vue";
import BoDInformationDetail from "../views/bod/Information/Detail.vue";
import MeetingIndex from "../views/meeting/Index.vue";
import MeetingDetail from "../views/meeting/Detail.vue";
import AdminMeetingParticipants from "../views/admin/meeting/Participants.vue";
import BODIndex from "../views/bod/Index.vue";
import ArchiveIndex from "../views/archive/Index.vue";
import ArchiveList from "../views/archive/List.vue";
import ManagerArchiveIndex from "../views/bod/archive/Index.vue";
import ManagerArchiveList from "../views/bod/archive/List.vue";
import BODDetail from "../views/bod/Detail.vue";
import BODParticipants from "../views/bod/Participants.vue";
import AdminBODEdit from "../views/admin/bod/Edit.vue";
import NotFound from "../views/NotFound.vue";
import AdminBoDInformation from "../views/admin/bod/Information/Index.vue";
import AdminBoDInformationEdit from "../views/admin/bod/Information/Edit.vue";
import AdminInformation from "../views/admin/information/Index.vue";
import AdminInformationEdit from "../views/admin/information/Edit.vue";
import AdminMeetingindex from "../views/admin/meeting/Index.vue";
import AdminMeetingEdit from "../views/admin/meeting/Edit.vue";
import ETohyo from "../views/ETohyo.vue";
import ChatAdmin from "../views/admin/meeting/ChatAdmin.vue";
import AdminUserIndex from "../views/admin/user/Index.vue";
import AdminUserEdit from "../views/admin/user/Edit.vue";
import AdminUserStatusIndex from "../views/admin/user_status/Index.vue";
import AdminUserStatusEdit from "../views/admin/user_status/Edit.vue";
import AdminArchiveEdit from "../views/admin/archive/Edit.vue";
import AdminManagerArchiveEdit from "../views/admin/bod/archive/Edit.vue";
import PasswodReminder from "../views/PasswordReminder.vue";
import PasswordReset from "../views/PasswordReset.vue";
import VerifyEmail from "../views/VerifyEmail.vue";
import Contact from "../views/Contact.vue";
import mcContact from "../views/mc/Contact.vue";
import mcTop from "../views/mc/Top.vue";
// import mcSoudan from "../views/mc/Soudan.vue";
import mcAfter from "../views/mc/After.vue";
// import mcAfterFuteiki from "../views/mc/AfterFuteiki.vue";
import mcSaigai from "../views/mc/Saigai.vue";
import mcMyPagePasswordEdit from "../views/mc/my_page/Password/Edit.vue";
import mcMyPageEmailEdit from "../views/mc/my_page/Email/Edit.vue";
import mcMyPageSettingsNotification from "../views/mc/my_page/Settings/Notification.vue";
import EmailRequired from "../views/email/Required.vue";
import AdminContactIndex from "../views/admin/contact/Index.vue";
import AdminContactEdit from "../views/admin/contact/Edit.vue";
import AdminOrderSchemaIndex from "../views/admin/order_schema/Index.vue";
import AdminOrderSchemaEdit from "../views/admin/order_schema/Edit.vue";
import AdminOrderIndex from "../views/admin/order/Index.vue";
import AdminOrderEdit from "../views/admin/order/Edit.vue";
import Order from "../views/mc/Order.vue";
import AdminEventIndex from "../views/admin/event/Index.vue";
import AdminEventEdit from "../views/admin/event/Edit.vue";
import AdminEventDetail from "../views/admin/event/Detail.vue";
import mcEventIndex from "../views/mc/event/Index.vue";
import mcEventDetail from "../views/mc/event/Detail.vue";
import mcEventDetail2 from "../views/mc/event/Detail2.vue";
import mcEventReserve from "../views/mc/event/Reserve.vue";
import mcEventReserve2 from "../views/mc/event/Reserve2.vue";

import GlobalInformationDetail from "../views/globalInformation/Detail.vue";
import BODTools from "../views/bod/Tools.vue";
import RSV from "../views/mc/RSV.vue";

import AdminAllocationIndex from "../views/admin/allocation/Index.vue";
import AdminAllocationSort from "../views/admin/allocation/Sort.vue";
import AdminAllocationEdit from "../views/admin/allocation/Edit.vue";
import AdminAllocationLotteryIndex from "../views/admin/allocation/lottery/Index.vue";
import AdminAllocationLotteryResult from "../views/admin/allocation/lottery/Result.vue";

import AllocationIndex from "../views/allocation/Index.vue";
import AllocationEntry from "../views/allocation/Entry.vue";
import AllocationLottery from "../views/allocation/Lottery.vue";
import AllocationResult from "../views/allocation/Result.vue";
import AllocationCompleted from "../views/allocation/Completed.vue";

import QA from "../views/QA.vue";

import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/login" },
  {
    path: "/verify-email",
    name: "verify-email",
    component: VerifyEmail,
    meta: { title: "メール確認", layout: "free" },
  },
  {
    path: "/contact/",
    name: "contact",
    component: Contact,
    meta: { title: "お問い合わせ", layout: "free" },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      layout: "free",
      title: "ログイン",
      desc:
        "グループの分譲マンションご入居者様・ご契約者様向けの会員サイトです。皆さまの生活をより豊かにしていただくために、マンションに関するお知らせや各種ご優待などを掲載させていただいております。",
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: { layout: "free" },
  },
  {
    path: "/rsv",
    name: "rsv",
    component: RSV,
    meta: { title: "RSV", desc: "", layout: "full" },
  },
  {
    path: "/:mc_code/logout",
    name: "mc-logout",
    component: Logout,
    meta: { layout: "free" },
  },
  {
    path: "/password-reminder",
    name: "password-reminder",
    component: PasswodReminder,
    meta: { title: "パスワードリマインダー", layout: "full" },
  },
  {
    path: "/password-reset",
    name: "password-reset",
    component: PasswordReset,
    meta: { title: "パスワード再設定", layout: "full" },
  },
  {
    path: "/:mc_code",
    name: "top",
    component: mcTop,
    meta: { title: "トップ", desc: "トップ" },
  },
  {
    path: "/:mc_code/mypage",
    name: "mypage",
    component: MyPageIndex,
    meta: { title: "マイページ", desc: "マイページ" },
  },

  {
    path: "/:mc_code/mypage/password",
    name: "mypage-password",
    component: mcMyPagePasswordEdit,
    meta: { title: "マイページ", desc: "マイページ" },
  },
  {
    path: "/:mc_code/mypage/email",
    name: "mypage-email",
    component: mcMyPageEmailEdit,
    meta: { title: "マイページ", desc: "マイページ" },
  },
  {
    path: "/:mc_code/email-required",
    name: "email-required",
    component: EmailRequired,
    meta: { title: "メールアドレス登録", layout: "full" },
  },
  {
    path: "/:mc_code/mypage/settings/notification",
    name: "mypage-settings-notification",
    component: mcMyPageSettingsNotification,
    meta: { title: "マイページ", desc: "マイページ" },
  },
  {
    path: "/:mc_code/qa",
    name: "qa",
    component: QA,
    meta: { title: "QA", desc: "" },
  },
  {
    path: "/:mc_code/etohyo",
    name: "etohyo",
    component: ETohyo,
    meta: { title: "出欠の提出", desc: "マイページ" },
  },
  {
    path: "/:mc_code/roommanagement",
    name: "roommanagement",
    component: RoomManagement,
  },
  {
    path: "/:mc_code/information/:id",
    name: "information-detail",
    component: InformationDetail,
    meta: { title: "お知らせ", desc: "" },
  },
  {
    path: "/:mc_code/information",
    name: "information-1",
    component: Information,
    alias: "/information/-1",
    meta: { title: "お知らせ", desc: "" },
  },
  {
    path: "/:mc_code/global-information/:id",
    name: "global-information-detail",
    component: GlobalInformationDetail,
    meta: { title: "お知らせ", desc: "" },
  },
  {
    path: "/:mc_code/bod/information/:id",
    name: "bod-information-detail",
    component: BoDInformationDetail,
    meta: { title: "理事会からのお知らせ", desc: "" },
  },
  {
    path: "/:mc_code/bod/information",
    name: "bod-information-1",
    component: BoDInformation,
    alias: "/bod/information/-1",
    meta: { title: "理事会からのお知らせ", desc: "" },
  },
  {
    path: "/:mc_code/bod/tools",
    name: "bod-tools",
    component: BODTools,
    alias: "/bod/tools",
    meta: { title: "理事会からのお知らせ", desc: "" },
  },
  {
    path: "/:mc_code/archive",
    name: "archive",
    component: ArchiveIndex,
    meta: { title: "マンション書庫", desc: "" },
  },
  {
    path: "/:mc_code/archive/:category",
    name: "archive-list",
    component: ArchiveList,
    meta: { title: "マンション書庫 一覧", desc: "" },
  },
  {
    path: "/:mc_code/admin/archive/edit/:id",
    name: "admin-archive-edit",
    component: AdminArchiveEdit,
    meta: {
      title: "[管理]マンション書庫 ファイル登録",
      desc: "",
      layout: "admin",
    },
  },
  {
    path: "/:mc_code/bod/archive",
    name: "bod-archive",
    component: ManagerArchiveIndex,
    meta: { title: "管理組合書庫", desc: "" },
  },
  {
    path: "/:mc_code/bod/archive/:category",
    name: "bod-archive-list",
    component: ManagerArchiveList,
    meta: { title: "マンション書庫 一覧", desc: "" },
  },
  {
    path: "/:mc_code/admin/bod/archive/edit/:id",
    name: "admin-bod-archive-edit",
    component: AdminManagerArchiveEdit,
    meta: {
      title: "[管理]管理組合書庫 ファイル登録",
      desc: "",
      layout: "admin",
    },
  },
  {
    path: "/:mc_code/admin/information",
    name: "admin-information",
    component: AdminInformation,
    meta: { title: "[管理]お知らせ", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/bod/information/edit/:id",
    name: "admin-bod-information-edit",
    component: AdminBoDInformationEdit,
    meta: {
      title: "[管理]理事会からのお知らせ編集",
      desc: "",
      layout: "admin",
    },
  },
  {
    path: "/:mc_code/admin/bod/information",
    name: "admin-bod-information",
    component: AdminBoDInformation,
    meta: { title: "[管理]理事会からのお知らせ", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/information/edit/:id",
    name: "admin-information-edit",
    component: AdminInformationEdit,
    meta: { title: "[管理]お知らせ編集", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/orderschema",
    name: "admin-order-schema",
    component: AdminOrderSchemaIndex,
    meta: { title: "[管理]申し込みフォーム一覧", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/orderschema/edit/:id?",
    name: "admin-order-schema-edit",
    component: AdminOrderSchemaEdit,
    meta: { title: "[管理]申し込みフォーム編集", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/order",
    name: "admin-order",
    component: AdminOrderIndex,
    meta: { title: "[管理]申し込み一覧", desc: "", layout: "admin" },
  },
  // {
  //   path: "/:mc_code/test",
  //   name: "test",
  //   component: Test,
  //   meta: { title: "テスト", desc: "" },
  // },
  {
    path: "/:mc_code/admin/order/edit/:id?",
    name: "admin-order-edit",
    component: AdminOrderEdit,
    meta: { title: "[管理]申し込み確認", desc: "", layout: "admin" },
  },

  {
    path: "/:mc_code/meeting",
    name: "meeting",
    component: MeetingIndex,
    meta: { title: "総会", desc: "" },
  },
  {
    path: "/:mc_code/meeting/:id",
    name: "meeting-detail",
    component: MeetingDetail,
    meta: { title: "総会詳細", desc: "" },
  },
  {
    path: "/:mc_code/admin/meeting/participants/:id",
    name: "admin-meeting-participants",
    component: AdminMeetingParticipants,
    meta: { title: "[管理]総会参加者", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/meeting",
    name: "admin-meeting-index",
    component: AdminMeetingindex,
    meta: { title: "[管理]総会", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/meeting/edit/:id",
    name: "admin-meeting-edit",
    component: AdminMeetingEdit,
    meta: { title: "[管理]総会編集", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/bod",
    name: "bod",
    component: BODIndex,
    meta: { title: "理事会", desc: "" },
  },
  {
    path: "/:mc_code/bod/detail/:id",
    name: "bod-detail",
    component: BODDetail,
    meta: { title: "理事会詳細", desc: "" },
  },
  {
    path: "/:mc_code/bod/participants/:id",
    name: "bod-participants",
    component: BODParticipants,
    meta: { title: "理事会", desc: "" },
  },
  // {
  //   path: "/:mc_code/bod/archives",
  //   name: "bodArchives",
  //   component: BODAchives,
  //   meta: { title: "理事会書類", desc: "" },
  // },
  {
    path: "/:mc_code/order/:directory",
    name: "order",
    component: Order,
    meta: { title: "申し込み", desc: "" },
  },
  // {
  //   path: "/bod/bbs",
  //   name: "bbs",
  //   component: BODBBS,
  // },
  {
    path: "/:mc_code/admin/bod/edit/:id",
    name: "admin-bod-edit",
    component: AdminBODEdit,
    meta: { title: "[管理]理事会編集", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/user",
    name: "admin-user",
    component: AdminUserIndex,
    meta: { title: "[管理]ユーザ管理", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/user/edit/:id",
    name: "admin-user-edit",
    component: AdminUserEdit,
    meta: { title: "[管理]ユーザ編集", desc: "", layout: "admin" },
  },

  {
    path: "/:mc_code/admin/user_status",
    name: "admin-user-status",
    component: AdminUserStatusIndex,
    meta: { title: "[管理]ユーザ移行管理", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/user_status/edit/:id",
    name: "admin-user-status-edit",
    component: AdminUserStatusEdit,
    meta: { title: "[管理]ユーザ移行編集", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/chat/:id",
    name: "admin-chat",
    component: ChatAdmin,
    meta: { title: "[管理]チャット管理", desc: "", layout: "admin" },
  },
  // {
  //   path: "/:mc_code/soudan/:id?",
  //   name: "mc-soudan",
  //   component: mcSoudan,
  //   meta: { title: "マンション売りたい・貸したい相談" },
  // },
  {
    path: "/:mc_code/after/:id?",
    name: "mc-after",
    component: mcAfter,
    meta: { title: "アフター申し込み" },
  },
  // {
  //   path: "/:mc_code/after-futeiki/:id?",
  //   name: "mc-after-futeki",
  //   component: mcAfterFuteiki,
  //   meta: { title: "アフター申し込み(不定期)" },
  // },
  {
    path: "/:mc_code/saigai/:id?",
    name: "mc-saigai",
    component: mcSaigai,
    meta: { title: "災害状況共有" },
  },
  {
    path: "/:mc_code/contact/:id?",
    name: "in-contact",
    component: mcContact,
    meta: { title: "お問い合わせ" },
  },
  {
    path: "/:mc_code/admin/contact",
    name: "admin-contact",
    component: AdminContactIndex,
    meta: { title: "問い合わせ一覧", desc: "マイページ", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/contact/edit/:id",
    name: "admin-contact-edit",
    component: AdminContactEdit,
    meta: { title: "問い合わせ確認", desc: "マイページ", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/event",
    name: "admin-event",
    component: AdminEventIndex,
    meta: { title: "イベント予約一覧", desc: "イベント予約", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/event/edit/:id?",
    name: "admin-event-edit",
    component: AdminEventEdit,
    meta: { title: "イベント予約編集", desc: "イベント予約", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/event/detail/:id",
    name: "admin-event-detail",
    component: AdminEventDetail,
    meta: { title: "イベント予約管理", desc: "イベント予約", layout: "admin" },
  },
  {
    path: "/:mc_code/event",
    name: "mc-event-index",
    component: mcEventIndex,
    meta: { title: "イベント予約一覧", desc: "イベント予約" },
  },
  {
    path: "/:mc_code/event/:previewid",
    name: "mc-event-detail",
    component: mcEventDetail,
    meta: { title: "イベント予約", desc: "イベント予約" },
  },
  {
    path: "/:mc_code/event/re-detail/:previewid",
    name: "mc-event-detail2",
    component: mcEventDetail2,
    meta: { title: "イベント予約変更", desc: "イベント予約" },
  },
  {
    path: "/:mc_code/event/reserve/:previewid/:scheduleIndex/:komaIndex",
    name: "mc-event-reserve",
    component: mcEventReserve,
    meta: { title: "イベント予約", desc: "イベント予約" },
  },
  {
    path:
      "/:mc_code/event/re-reserve/:previewid/:reserveid/:scheduleIndex/:komaIndex",
    name: "mc-event-reserve2",
    component: mcEventReserve2,
    meta: { title: "イベント予約変更", desc: "イベント予約" },
  },
  {
    path: "/:mc_code/rsv",
    name: "rsv-index",
    component: RSV,
    meta: { title: "RSV", desc: "", layout: "full" },
  },
  {
    path: "/:mc_code/admin/allocation",
    name: "admin-allocation-index",
    component: AdminAllocationIndex,
    meta: { title: "[管理]申込マスタ管理", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/allocation/sort",
    name: "admin-allocation-sort",
    component: AdminAllocationSort,
    meta: { title: "[管理]申込並び順管理", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/allocation/:allocation_id?/edit",
    name: "admin-allocation-edit",
    component: AdminAllocationEdit,
    meta: { title: "[管理]申込マスタ登録・編集", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/allocation/:allocation_id/lottery",
    name: "admin-allocation-lottery-index",
    component: AdminAllocationLotteryIndex,
    meta: { title: "[管理]申込抽選管理", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/admin/allocation/lottery/:allocation_id/result",
    name: "admin-allocation-lottery-result",
    component: AdminAllocationLotteryResult,
    meta: { title: "[管理]申込割付管理", desc: "", layout: "admin" },
  },
  {
    path: "/:mc_code/allocation",
    name: "allocation-index",
    component: AllocationIndex,
    meta: { title: "申込メニュー", desc: "" },
  },
  {
    path: "/:mc_code/allocation/:id/entry",
    name: "allocation-entry",
    component: AllocationEntry,
    meta: { title: "申込", desc: "" },
  },
  {
    path: "/:mc_code/allocation/:id/completed",
    name: "allocation-complated",
    component: AllocationCompleted,
    meta: { title: "申込完了", desc: "" },
  },
  {
    path: "/:mc_code/allocation/:id/lottery",
    name: "allocation-lottery",
    component: AllocationLottery,
    meta: { title: "抽選中", desc: "" },
  },
  {
    path: "/:mc_code/allocation/:id/result",
    name: "allocation-result",
    component: AllocationResult,
    meta: { title: "抽選結果", desc: "" },
  },
  {
    path: "/404",
    name: "notfound404",
    component: NotFound,
    meta: { layout: "free" },
  },
  {
    path: "*",
    name: "notfound",
    component: NotFound,
    meta: { layout: "free" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line
  scrollBehavior: async (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }

    const findEl = async (hash, x) => {
      return (
        document.querySelector(hash) ||
        // eslint-disable-next-line
        new Promise((resolve, reject) => {
          if (x > 50) {
            return resolve();
          }
          setTimeout(() => {
            resolve(findEl(hash, ++x || 1));
          }, 100);
        })
      );
    };

    if (to.hash) {
      const el = await findEl(to.hash);

      if ("scrollBehavior" in document.documentElement.style) {
        return window.scrollTo({ top: el.offsetTop, behavior: "smooth" });
      } else {
        return window.scrollTo(0, el.offsetTop);
      }
    }

    return { x: 0, y: 0 };
  },
});

Vue.use(
  VueGtag,
  {
    config: { id: `${process.env.VUE_APP_FIREBASE_MEASURMENT_ID}` },
    params: {
      send_page_view: false,
    },
    // pageTrackerTemplate(to) {
    //   return {
    //     page_title: to.title,
    //     page_path: `/hoge/${to.path}`,
    //     hoge: "abc",
    //   };
    // },
  },
  router,
);

export default router;
